import React from "react";
import { COURSES } from "./courseData";

const LanguageLandingCourses = ({ activeTab, onTabChange, onBookDemo }) => {
  const tabs = Object.keys(COURSES);

  return (
    <section id="ll-courses" className="ll-section ll-courses">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="ll-section-label">Courses &amp; Pricing</span>
          <h2 className="about_head">
            Pick Your Language,{" "}
            <span className="highlighted-text">Start Your Journey</span>
          </h2>
          <p className="ll-section-subtitle">
            All courses include live classes, study materials, and a completion
            certificate.
          </p>
        </header>

        <div className="ll-tabs wow fadeInUp">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`ll-tab-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => onTabChange(tab)}
            >
              {COURSES[tab].flag} {COURSES[tab].label}
            </button>
          ))}
        </div>

        <div className="ll-courses-grid">
          {COURSES[activeTab].courses.map((course, index) => (
            <div
              key={course.title}
              className={`ll-course-card box course-card wow fadeInUp ${
                course.popular ? "ll-course-card--popular" : ""
              }`}
              data-wow-delay={`${index * 0.1}s`}
            >
              {course.popular && (
                <span className="ll-course-card__badge">Most Popular</span>
              )}
              <span className="ll-course-card__level">{course.level}</span>
              <h4 className="highlighted-text">{course.title}</h4>
              <ul>
                <li>Live online classes</li>
                <li>Duration: {course.duration}</li>
                <li>Certificate included</li>
              </ul>
              <div className="ll-course-card__price">₹{course.price.toLocaleString("en-IN")}</div>
              <button
                type="button"
                className="pay-btn"
                onClick={() =>
                  onBookDemo(COURSES[activeTab].label, course.formLevel, activeTab)
                }
              >
                Book Demo
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LanguageLandingCourses;
